export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200 py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-background-50 text-sm"></i>
              </span>
              <span className="text-base font-heading text-background-50">爱丫爱丫影院</span>
            </div>
            <p className="text-xs text-background-400 leading-relaxed">
              专注高清流畅观影的免费在线影院平台。秒开播放，无广告不缓冲，极速观影体验，涵盖电影、电视剧、动漫、纪录片等全品类内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-3">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '精选推荐', href: '#cards' },
                { label: '热播榜单', href: '#ranking' },
                { label: '最新动态', href: '#updates' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="block text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-3">影片分类</h4>
            <div className="space-y-2">
              {['动作大片', '科幻巨制', '悬疑推理', '浪漫爱情', '热门剧集', '经典老片'].map((cat) => (
                <span key={cat} className="block text-xs text-background-400 whitespace-nowrap">{cat}</span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-3">合作伙伴</h4>
            <p className="text-xs text-background-500">合作品牌与媒体伙伴即将揭晓，敬请期待。</p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2024 - 2026 爱丫爱丫影院. 本站所有内容仅供学习交流，请于下载后 24 小时内删除。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">使用条款</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}